/* eslint-disable */
export default class ModalRenderer {    
    constructor() {
        runnerId;
        component: {};
        data: {}    
    }
}